import styled from 'styled-components'

export const Wrapper = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1051; /* acima do RightSidebar (1050 no template) */
`

export const ToggleButton = styled.button`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background: #1a1d27;
  color: #4ade80;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 18px;
  font-weight: 700;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease;

  &:hover {
    transform: scale(1.06);
  }
`

export const Panel = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: ${(props) => (props.expandido ? '86vh' : '360px')};
  background: #12141c;
  border-top: 1px solid #2a2d37;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  font-family: 'Consolas', 'Monaco', 'Menlo', monospace;
  z-index: 1051;
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #1a1d27;
  border-bottom: 1px solid #2a2d37;
  flex-shrink: 0;
`

export const HeaderTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .tab {
    color: #d1d5db;
    font-size: 13px;
    padding: 4px 10px;
    border-radius: 4px;

    &.active {
      background: #2a2d37;
      color: #fff;
    }
  }

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;

    &.on {
      background: #4ade80;
    }

    &.off {
      background: #6b7280;
    }
  }
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  button {
    background: transparent;
    border: 1px solid #2a2d37;
    color: #d1d5db;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: #2a2d37;
      color: #fff;
    }
  }
`

export const Body = styled.div`
  flex: 1;
  display: flex;
  min-height: 0;
`

export const FiltersPanel = styled.div`
  width: 220px;
  flex-shrink: 0;
  background: #181a20;
  border-right: 1px solid #2a2d37;
  padding: 14px;
  overflow-y: auto;
`

export const FiltersPanelHeader = styled.div`
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 6px;

  .badge {
    background: #4ade80;
    color: #0b0f0c;
    font-size: 11px;
    font-weight: 700;
    border-radius: 10px;
    padding: 1px 7px;
  }
`

export const FilterGroup = styled.div`
  margin-bottom: 12px;

  input,
  select {
    width: 100%;
    background: #12141c;
    border: 1px solid #2a2d37;
    color: #e5e7eb;
    font-size: 12px;
    padding: 5px 8px;
    border-radius: 4px;
    font-family: inherit;

    &:focus {
      outline: none;
      border-color: #4ade80;
    }
  }
`

export const FilterLabel = styled.div`
  color: #9ca3af;
  font-size: 11px;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`

export const FilterActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;

  button {
    flex: 1;
    font-size: 12px;
    padding: 6px 0;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid transparent;

    &.secondary {
      background: transparent;
      border-color: #2a2d37;
      color: #d1d5db;

      &:hover {
        background: #2a2d37;
      }
    }

    &.primary {
      background: #22c55e;
      color: #0b0f0c;
      font-weight: 600;

      &:hover {
        background: #4ade80;
      }
    }
  }
`

export const TerminalArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 14px;
  font-size: 12.5px;
  line-height: 1.6;

  .linha-sistema {
    color: #6b7280;
    font-style: italic;
  }
`

const NIVEL_COR = {
  OK: '#4ade80',
  PROCESSANDO: '#38bdf8',
  ERRO: '#f87171',
}

export const TerminalLine = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  color: #d1d5db;

  .ts {
    color: #6b7280;
  }

  .nivel {
    color: ${(props) => NIVEL_COR[props.nivel] || '#d1d5db'};
    font-weight: 700;
  }

  .tipo {
    color: #a78bfa;
  }

  .empresa {
    color: #6b7280;
  }

  .mensagem {
    color: ${(props) => (props.nivel === 'ERRO' ? '#fca5a5' : '#e5e7eb')};
  }
`
